import RefreshIcon from "@mui/icons-material/Refresh";
import { Button } from "@mui/material";

interface Props {
  needsReauth: boolean;
  onClick?: () => void;
}

export default function ReauthenticateButton({ needsReauth, onClick }: Props) {
  if (!needsReauth) return null;

  return (
    <Button
      variant="contained"
      color="warning"
      size="small"
      startIcon={<RefreshIcon />}
      onClick={onClick}
      sx={{ boxShadow: 0 }}
    >
      Re-authenticate
    </Button>
  );
}
